import { type JSX } from "react";

import { DashboardType } from "@doitintl/cmp-models";

import { useCurrentDashboardContext } from "../../Context/useCurrentDashboardContext";
import { KubernetesLensGuard } from "../../Pages/K8s/Dashboard/KubernetesLens";
import GkeUsageAlert from "../Alerts/GkeUsageAlert";
import BigQueryLensGuard from "./BigQueryLens/BigQueryLensGuard";
import { IntegrationGuard } from "./CommonIntegrationLens/IntegrationGuard";
import { getIntegrationNameFromDashboardType, isCommonIntegrationLens } from "./CommonIntegrationLens/utils";
import { EKSLensGuard } from "./EKSLens/EKSLensGuard";
import GKELensGuard from "./GKELens/GKELensGuard";
import { MAPLensGuard } from "./MAPLens/MAPLensGuard";

type Props = {
  children: JSX.Element;
};

export function DashboardGuard({ children }: Props) {
  const { dashboardType } = useCurrentDashboardContext();

  if (isCommonIntegrationLens(dashboardType) && dashboardType) {
    const integrationName = getIntegrationNameFromDashboardType(dashboardType);

    if (integrationName) {
      return <IntegrationGuard integrationName={integrationName}>{children}</IntegrationGuard>;
    }
  }

  switch (true) {
    case dashboardType === DashboardType.EKSLens:
      return <EKSLensGuard>{children}</EKSLensGuard>;
    case dashboardType === DashboardType.GkeLensV2:
      return <>{children && <GKELensGuard>{children}</GKELensGuard>}</>;
    case dashboardType === DashboardType.BqLens:
      return <>{children && <BigQueryLensGuard>{children}</BigQueryLensGuard>}</>;
    case dashboardType === DashboardType.AWSMAPLens:
      return <MAPLensGuard>{children}</MAPLensGuard>;
    case dashboardType === DashboardType.KubernetesLens:
      return <KubernetesLensGuard>{children}</KubernetesLensGuard>;
    case dashboardType === DashboardType.GcpLens:
      return (
        <>
          <GkeUsageAlert />
          {children}
        </>
      );
    default:
      return <>{children}</>;
  }
}
